import React from "react";
import Card from "react-bootstrap/Card";
import { IoIosArrowForward } from "react-icons/io";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Ayush Godbole </span>
            from <span className="purple">Nagpur, Maharashtra, India.</span>
            <br />
            I am currently a Final year student at <span className="purple">Indian Institute of Information Technology, Nagpur.</span>
            <br />
            I'm currently looking for an internship opportunity. It's great to connect with you.
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <IoIosArrowForward /> Sports like Cricket and Football
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Online Gaming
            </li>
            <li className="about-activity">
              <IoIosArrowForward /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(109, 55, 204)" }}>
            "Learn new things, explore opportunities!"{" "}
          </p>
          <footer className="blockquote-footer">Ayush Godbole</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
